var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header-wrapper"},[_c('Header'),_c('Social')],1),_c('router-view'),_c('footer',[_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }